import gsap from 'gsap'

let finalWidth = "";
let startWidth = "";
let xWoman = 0;
let xTree = 0;

if (window.innerWidth < 767)
{
  finalWidth = "1500px";
  startWidth = "2500px";
  xWoman = -1000 + window.innerWidth/2;
  xTree = -800 + window.innerWidth/2;
}
else if (window.innerWidth < 1000)
{
  finalWidth = "1400px";
  startWidth = "2800px";
  xWoman = -850 + window.innerWidth/2;
  xTree = -800 + window.innerWidth/2;
}
else
{
  finalWidth = "100%";
  startWidth = "150%";
}

export function womanAnimation () {
  gsap.set('#womanImage', {
    duration: 6,
    ease: "power1.out",
    width: finalWidth,
    autoAlpha: 1,
    x: xWoman,
    y: 0
  });
  
  gsap.from('#womanImage', {
    duration: 6,
    ease: "power1.out",
    width: startWidth,
    autoAlpha: 0,
    x: "-30%",
    y: "50%"
  });

  gsap.set('#treeImage', {
    duration: 6,
    ease: "power1.out",
    width: finalWidth,
    autoAlpha: 1,
    x: xTree,
    y: 0
  });
  
  gsap.from('#treeImage', {
    duration: 6,
    ease: "power1.out",
    width: startWidth,
    autoAlpha: 0,
    x: "-30%",
    y: "50%"
  });
}